import { Calculator, Fire, Info } from "@phosphor-icons/react";
import { formatNumber } from "../utils/formatNumber";
import DataFieldCard from "./DataFieldCard";
import SectionTitle from "./SectionTitle";
import Typography from "./Typography";
import Chip from "./Chip";
import { ConfidenceName, confidenceNameToRagMap } from "../constants";
import Tooltip from "./Tooltip";

type DataSourceCalculationCardsProps = {
    rawUnitsSuffixHtml: string;
    currentNormalizedUnitsSuffixHtml: string;
    currentConversionFactor?: number;
    confidenceName?: ConfidenceName;
    currentEmissionsFactor?: number;
    confidenceReason?: string;
    
}

const DataSourceCalculationCards = ({
    rawUnitsSuffixHtml,
    currentConversionFactor,
    currentNormalizedUnitsSuffixHtml,
    confidenceName,
    currentEmissionsFactor,
    confidenceReason
}: DataSourceCalculationCardsProps) => {
    return <>
        <SectionTitle title="Conversion factor" variant="title-large" />
        <div className="space-y-6 sm:space-y-0 sm:grid sm:grid-cols-2 md-lg:grid-cols-3 sm:gap-6">
            <DataFieldCard
                title="Raw unit"
                value={rawUnitsSuffixHtml ?? "--"}
                icon={Fire}
            />
            <DataFieldCard
                title="Conversion factor"
                value={
                    formatNumber(currentConversionFactor) || ""
                }
                icon={Calculator}
            />
            <DataFieldCard
                title="Normalized units"
                value={currentNormalizedUnitsSuffixHtml ?? "--"}
                icon={Fire}
            />
        </div>
        <SectionTitle title="Emissions factor" variant="title-large" noSeperator />
        {confidenceName && 
        <div className="flex flex-row gap-1">
            <Typography
                variant="body-large"
                component="span"
                className="overflow-hidden overflow-ellipsis"
            >
            <b>Certainty:</b>{" "}
            
            </Typography>
            <Chip colour={confidenceNameToRagMap[confidenceName]}>{confidenceName}</Chip>
            <Tooltip
                text={
                    !confidenceReason
                        ? "Justification: none given."
                        : `Justification: ${
                            confidenceReason ??
                                ""
                            }`
                }
            >
                <Info
                    weight="fill"
                    size={24}
                    className="text-teal-60"
                />
            </Tooltip>
        </div>}
        
        
        <div className="space-y-6 mt-8 sm:space-y-0 sm:grid sm:grid-cols-2 md-lg:grid-cols-3 sm:gap-6">
            <DataFieldCard
                title="Input unit"
                value={currentNormalizedUnitsSuffixHtml}
                icon={Fire}
            />
            <DataFieldCard
                title="Emissions Factor"
                value={
                    formatNumber(
                        currentEmissionsFactor
                    ) ?? "--"
                }
                icon={Calculator}
            />            
            <DataFieldCard
                title="Output unit"
                value={"kg CO<sub>2</sub>e"}
                icon={Fire}
            />
        </div>
    </>;
};

export default DataSourceCalculationCards;